import axiosInstance, { axiosMultipartFormDataInstance } from './axiosInstance';
import { API_PATH, API_VERSION } from './constants';
const creativeUploadService = {
    getCreative: (companyId)=>axiosInstance.get(
        `/${API_VERSION}/${API_PATH.CREATIVE_UPLOAD}/${companyId}`
    ),
    getCreativeById: (Id)=>axiosInstance.get(
        `/${API_VERSION}/${API_PATH.CREATIVE_BY_ID}/${Id}`
    ),
    postCreativeUpload: (data)=>axiosMultipartFormDataInstance.post(
        `/${API_VERSION}/${API_PATH.CREATIVE_UPLOAD}`,data
    ),
    deleteCreative: (companyId, data)=>axiosInstance.post(
        `/${API_VERSION}/${API_PATH.CREATIVE_UPLOAD}/${companyId}/${API_PATH.DELETE}`,data
    ),
    editCreative: (data,id)=>axiosMultipartFormDataInstance.post(
        `/${API_VERSION}/${API_PATH.CREATIVE_UPLOAD}/${id}/${API_PATH.EDIT}`,data
    )
};
export default creativeUploadService;